<template>
  <div class="box">
    <div class="inner">
      <h3>{{ $t('view.component.contacts.list.savedNumbersHeader') }}</h3>
      <div class="single-phone"
           v-for="(contact, index) in contacts"
           :key="index"
           :class="{'last': isLastContact(index)}">
        <div class="left-col">
          <div class="with-checkbox">
            <input type="checkbox"
                   v-model="form.topup"
                   :value="contact"
                   :id="'phone_' + index"
                   name="phone" />
            <label :for="'phone_' + index">
                  <span>
                    <span class="number">{{ contact.msisdn | phone }}</span>
                    <span>{{ contact.description }}</span>
                  </span>
            </label>
          </div>
          <div class="actions">
            <a class="bold" @click.prevent="goToContactEdit(contact)">{{ $t('view.component.contacts.list.buttonEdit') }}</a>
            <a class="bold" @click.prevent="showContactDeleteModal(contact)">{{ $t('view.component.contacts.list.buttonDelete') }}</a>
          </div>
        </div>
        <div class="right-col">
          <div class="additional" v-if="contact.recurringTopup">
            <div class="row autotopup">
              <p class="mb-10">
                <span>{{ $t('view.component.contacts.list.autotopup') }}</span>
                <span class="status">
                  <span class="bold" v-if="!isAutotopupInactive(contact)">{{ $t('view.component.contacts.list.statusActive') }}</span>
                  <img src="../../assets/images/enabled.svg" v-if="!isAutotopupInactive(contact)" alt="" />
                  <span class="bold" v-if="isAutotopupInactive(contact)">{{ $t('view.component.contacts.list.statusInactive') }}</span>
                  <img src="../../assets/images/error.svg" v-if="isAutotopupInactive(contact)" alt="" />
                </span>
              </p>
              <p class="mb-10">
                <span>{{ $t('view.component.contacts.list.paymentMethod') }}:</span>
                <span class="bold" v-if="isAutotopupPaymentMethodCard(contact)">{{ $t('view.component.contacts.list.paymentMethodCard') }}</span>
                <span class="bold" v-if="isAutotopupPaymentMethodBlik(contact)">{{ $t('view.component.contacts.list.paymentMethodBlik') }}</span>
              </p>
              <div class="actions" v-if="isAutotopupInactive(contact)">
                <a class="bold" v-if="isAutotopupPaymentMethodCard(contact)" @click.prevent="goToAddPaymentCardMethod">{{ $t('view.component.contacts.list.buttonAddCreditCard') }}</a>
                <a class="bold" v-if="isAutotopupPaymentMethodCard(contact) && isUserPaymentTypeBlikSet" @click.prevent="changeToAddPaymentBlikMethod(contact)">{{ $t('view.component.contacts.list.buttonUseBlik') }}</a>
                <a class="bold" v-if="isAutotopupPaymentMethodBlik(contact)" @click.prevent="goToAddPaymentBlikMethod">{{ $t('view.component.contacts.list.buttonAddBlik') }}</a>
                <a class="bold" v-if="isAutotopupPaymentMethodBlik(contact) && isUserPaymentMethodCreditCardActive" @click.prevent="changeToAddPaymentCardMethod(contact)">{{ $t('view.component.contacts.list.buttonUseCard') }}</a>
                <a class="bold" v-if="isUserPaymentMethodCreditCardSet && !isUserPaymentMethodCreditCardActive" @click.prevent="goToPaymentData">{{ $t('view.component.contacts.list.buttonChangeCreditCard') }}</a>
                <a class="bold" @click.prevent="showAutotopupDeleteModal(contact)">{{ $t('view.component.contacts.list.buttonDisable') }}</a>
              </div>
              <div class="actions" v-if="!isAutotopupInactive(contact)">
                <a class="bold" v-if="isAutotopupPaymentMethodCard(contact) && isUserPaymentTypeBlikSet" @click.prevent="changeToAddPaymentBlikMethod(contact)">{{ $t('view.component.contacts.list.buttonUseBlik') }}</a>
                <a class="bold" v-if="isAutotopupPaymentMethodBlik(contact) && isUserPaymentMethodCreditCardActive" @click.prevent="changeToAddPaymentCardMethod(contact)">{{ $t('view.component.contacts.list.buttonUseCard') }}</a>
                <a class="bold" @click.prevent="showAutotopupDeleteModal(contact)">{{ $t('view.component.contacts.list.buttonDisable') }}</a>
              </div>
            </div>
            <div class="row">
              <p>
                <span>{{ $t('view.component.contacts.list.labelThreshold') }}</span>
                <span class="bold amount">{{ contact.recurringTopup.threshold | pln }} zł</span>
              </p>
              <p>
                <span>{{ $t('view.component.contacts.list.labelAmount') }}</span>
                <span class="bold amount">{{ contact.recurringTopup.amount | pln }} zł</span>
              </p>
            </div>
            <div class="row">
              <p>
                <span>{{ $t('view.component.contacts.list.labelBalance') }}</span>
                <span class="bold amount">{{ contact.currentBalance | pln }} zł</span>
              </p>
              <p>
                <span>{{ $t('view.component.contacts.list.labelBalanceExpiration') }}</span>
                <span class="bold amount">{{ contact.balanceExpiration }}</span>
              </p>
            </div>
          </div>
          <div class="additional" v-if="!contact.recurringTopup">
            <div class="row autotopup">
              <p>
                <span>{{ $t('view.component.contacts.list.autotopup') }}</span>
              </p>
              <div class="actions">
                <a class="bold" @click.prevent="activateAutoTopup(contact)">{{ $t('view.component.contacts.list.buttonEnable') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="submit" v-if="contacts.length">
        <button type="button"
                class="primary"
                :disabled="!form.topup.length"
                @click="quickTopup">
          {{ $t('view.component.contacts.list.buttonTopup') }}
        </button>
      </div>
      <p v-if="!contacts.length">
        {{ $t('view.component.contacts.list.emptyList') }}
      </p>
    </div>
    <Sidebar v-if="removeContactSidebarVisible"
             :sidebar-visible="true"
             :buttons-visible="true"
             :button-confirm="removeContactConfirmButton"
             @sidebarClose="hideContactDeleteModal">
      <RemoveContactSidebar />
    </Sidebar>
    <Sidebar v-if="removeAutotopupSidebarVisible"
             :sidebar-visible="true"
             :buttons-visible="true"
             :button-confirm="removeAutotopupConfirmButton"
             @sidebarClose="hideAutotopupDeleteModal">
      <RemoveAutotopupSidebar />
    </Sidebar>
  </div>
</template>

<script>
import { ROUTING } from '@/orange/const/routing.const'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { AUTO_TOPUP_TYPE_DATE_CONDITION, TOPUP_TEMPLATE } from '@/common/const/topup.const'
import { ToolsClass } from '@/common/class/tools.class'
import RemoveAutotopupSidebar from '@/orange/components/Contacts/RemoveAutotopupSidebar'
import RemoveContactSidebar from '@/orange/components/Contacts/RemoveContactSidebar'
import Sidebar from '@/orange/components/common/Sidebar'
import { Notifier, NOTIFY_TYPE } from '@/common/class/notify.class'
import { PAYMENT_METHOD_TYPE } from '@/common/const/payment.const'

export default {
  name: 'ContactsList',
  components: {
    Sidebar,
    RemoveContactSidebar,
    RemoveAutotopupSidebar
  },
  computed: {
    ...mapState({
      isLoading: state => state.contacts.loading,
      userData: state => state.user.data,
      autotopup: state => state.autotopup.data
    }),
    ...mapGetters({
      contacts: 'getContactsList',
      isUserPaymentMethodCreditCardActive: 'isUserPaymentMethodCreditCardActive',
      isUserPaymentMethodCreditCardSet: 'isUserPaymentMethodCreditCardSet',
      isUserPaymentTypeBlikSet: 'isUserPaymentTypeBlikSet'
    })
  },
  data () {
    return {
      removeContactId: null,
      removeContactSidebarVisible: false,
      removeContactConfirmButton: {
        title: this.$t('view.component.contacts.list.removeButton'),
        callback: this.deleteContact
      },
      removeAutotopupId: null,
      removeAutotopupSidebarVisible: false,
      removeAutotopupConfirmButton: {
        title: this.$t('view.component.contacts.list.removeButton'),
        callback: this.deleteAutotopup
      },
      form: {
        topup: []
      }
    }
  },
  methods: {
    ...mapActions([
      'getContacts',
      'setStage1Data',
      'removeAutotopup',
      'removeContact',
      'updateAutotopup'
    ]),
    ...mapMutations([
      'SET_TOPUP_STAGE',
      'SET_AUTOTOPUP_DATA'
    ]),
    isAutotopupPaymentMethodCard (contact) {
      return contact.recurringTopup?.paymentMethodType === PAYMENT_METHOD_TYPE.creditCard
    },
    isAutotopupPaymentMethodBlik (contact) {
      return contact.recurringTopup?.paymentMethodType === PAYMENT_METHOD_TYPE.blikRecurring
    },
    isAutotopupInactive (contact) {
      return (this.isAutotopupPaymentMethodCard(contact) && !this.isUserPaymentMethodCreditCardActive) ||
        (this.isAutotopupPaymentMethodBlik(contact) && !this.isUserPaymentTypeBlikSet)
    },
    isLastContact (index) {
      return index === this.contacts.length - 1
    },
    goToContactEdit (contact) {
      this.$router.push({ path: ROUTING.contacts.edit, query: { id: contact.id } })
    },
    showContactDeleteModal (contact) {
      this.removeContactId = contact.id
      this.removeContactSidebarVisible = true
    },
    hideContactDeleteModal () {
      this.removeContactId = null
      this.removeContactSidebarVisible = false
    },
    deleteContact (callback) {
      this.removeContact(this.removeContactId)
        .then(() => {
          Notifier.show({
            text: this.$t('view.component.contacts.list.contactRemoveProcessSuccess'),
            type: NOTIFY_TYPE.success
          })
        })
        .catch(() => {
          Notifier.show({
            text: this.$t('view.component.contacts.list.contactRemoveProcessError'),
            type: NOTIFY_TYPE.error
          })
        })
        .finally(() => {
          callback()
          this.getContacts()
        })
    },
    showAutotopupDeleteModal (contact) {
      this.removeAutotopupId = contact.recurringTopup.id
      this.removeAutotopupSidebarVisible = true
    },
    hideAutotopupDeleteModal () {
      this.removeAutotopupId = null
      this.removeAutotopupSidebarVisible = false
    },
    deleteAutotopup (callback) {
      this.removeAutotopup(this.removeAutotopupId)
        .then(() => {
          Notifier.show({
            text: this.$t('view.component.contacts.list.autotopupRemoveProcessSuccess'),
            type: NOTIFY_TYPE.success
          })
        })
        .catch(() => {
          Notifier.show({
            text: this.$t('view.component.contacts.list.autotopupRemoveProcessError'),
            type: NOTIFY_TYPE.error
          })
        })
        .finally(() => {
          callback()
          this.getContacts()
        })
    },
    goToPaymentData () {
      this.$router.push(ROUTING.user.data)
    },
    goToAddPaymentCardMethod () {
      this.$router.push(ROUTING.creditCard)
    },
    changeToAddPaymentBlikMethod (contact) {
      const autoTopupData = {
        id: contact.recurringTopup.id,
        day: contact.recurringTopup.day,
        recurringTopupType: contact.recurringTopup.recurringTopupType,
        paymentMethodType: PAYMENT_METHOD_TYPE.blikRecurring,
        amount: parseInt(contact.recurringTopup.amount, 10),
        threshold: parseInt(contact.recurringTopup.threshold, 10),
        msisdn: contact.msisdn
      }
      return this.updateAutotopup(autoTopupData)
        .finally(() => {
          this.getContacts()
        })
    },
    changeToAddPaymentCardMethod (contact) {
      const autoTopupData = {
        id: contact.recurringTopup.id,
        day: contact.recurringTopup.day,
        recurringTopupType: contact.recurringTopup.recurringTopupType,
        paymentMethodType: PAYMENT_METHOD_TYPE.creditCard,
        amount: parseInt(contact.recurringTopup.amount, 10),
        threshold: parseInt(contact.recurringTopup.threshold, 10),
        msisdn: contact.msisdn
      }
      return this.updateAutotopup(autoTopupData)
        .finally(() => {
          this.getContacts()
        })
    },
    goToAddPaymentBlikMethod () {
      this.$router.push(ROUTING.blik)
    },
    quickTopup () {
      if (!this.form.topup.length) {
        return
      }
      const topupData = {
        topup: [],
        email: this.userData.email
      }
      this.form.topup.forEach(contact => {
        topupData.topup.push(Object.assign({}, TOPUP_TEMPLATE,
          { phone: ToolsClass.getPhoneNumberWithoutPrefix(contact.msisdn), contact: contact, isContact: true }))
      })
      this.setStage1Data(topupData)
        .then(() => {
          this.SET_TOPUP_STAGE(2)
          this.$router.push(ROUTING.topup.single.step2)
        })
    },
    activateAutoTopup (contact) {
      const data = ToolsClass.deepExtend(this.autotopup)
      data.recurringTopupType = AUTO_TOPUP_TYPE_DATE_CONDITION.balance
      data.contact.msisdn = contact.msisdn
      data.contact.description = contact.description
      this.SET_AUTOTOPUP_DATA(data)
      this.$router.push(ROUTING.topup.auto.step1)
    }
  },
  created () {
    this.getContacts()
  }
}
</script>

<style lang="scss" src="../../assets/scss/components/_phone-list.scss" scoped></style>
